/* eslint-disable no-underscore-dangle */
/* eslint-disable import/no-extraneous-dependencies */
import axios from 'axios';
import * as uuid from 'uuid';
import { GoogleAuthProvider, getAuth, linkWithPopup } from 'firebase/auth';
import { get } from 'svelte/store';
import { firstValueFrom } from 'rxjs';
import { map } from 'rxjs/operators';

import { user, account, pending, ux, siteMap, accountForms, accountSites, accountSiteMap } from './store';
import { api } from './config';
import { alphasort, formatMoney } from './util';

function buildHeaders(...keys) {
  const finalHeaders = {
    'content-type': 'application/json',
  };

  keys.forEach((key) => {
    const $user = get(user);
    const $account = get(account);
    if (key === 'ikey') {
      finalHeaders['x-webforma-ikey'] = uuid.v4();
    }
    else if (key === 'uid' && $user?.uid) {
      finalHeaders['x-webforma-uid'] = $user?.uid;
    }
    else if (key === 'aid' && $account?._id) {
      finalHeaders['x-webforma-aid'] = $account?._id;
    }
  });

  return finalHeaders;
}
export async function createFirstSite(payload = {}) {
  console.count('services.createFirstSite');

  let response = null;
  try {
    response = await axios.post(api.sites.first.url, payload, {
      headers: buildHeaders('uid', 'aid'),
    });
  } catch (error) {
    return error;
  }
  return response;
}
export async function createForm(payload = {}) {
  console.count('services.createForm');

  let response = null;
  try {
    response = await axios.post(api.forms.add.url, payload, {
      headers: buildHeaders('uid', 'aid'),
    });
  } catch (error) {
    return error;
  }
  return response?.data?.result;
}
export async function createSite(payload = {}) {
  console.count('services.createSite');

  let response = null;
  try {
    response = await axios.post(api.sites.add.url, payload, {
      headers: buildHeaders('uid', 'aid'),
    });
  } catch (error) {
    return error;
  }
  return response;
}
export async function createSub(payload = {}) {
  console.count('services.createSub');

  let response = null;
  try {
    response = await axios.post(api.account.createSubs.url, payload, {
      headers: buildHeaders('uid', 'aid', 'ikey'),
    });

    ux.update((uxs) => {
      uxs.inspect = response;
      return uxs;
    });
  } catch (error) {
    return error;
  }
  return response;
}
export async function deleteForm(payload = { id: null }) {
  console.count('services.deleteForm');

  let success = false;
  try {
    const headers = buildHeaders('aid', 'uid');
    const response = await axios.post(api.forms.delete.url, payload, {
      headers,
    });
    success = response?.data?.success;
  } catch (error) {
    console.log('Failed to the delete the site', payload);
    console.error(error);
  }
  return success;
}
export async function deleteSiteSvc(payload = {}) {
  console.count('services.deleteSiteSvc');

  let success = false;
  try {
    const headers = buildHeaders('aid', 'uid');
    const response = await axios.post(api.sites.delete.url, payload, {
      headers,
    });
    success = response?.data?.success;
  } catch (error) {
    console.log('Failed to the delete the site', payload);
    console.error(error);
  }
  return success;
}
export async function deleteSubmission(payload = { id: null, fid: null }) {
  console.count('services.deleteSubmission');
  let success = false;
  try {
    const response = await axios.post(api.submissions.delete.url, payload, {
      headers: { ...buildHeaders('uid'), 'x-webforma-fid': payload.fid },
    });
    success = response?.data?.success;
  } catch (error) {
    console.log('Failed to the delete the submission', payload);
    console.error(error);
  }
  return success;
}
export async function editForm(payload = { fid: null }) {
  console.count('services.editForm');

  let response = null;
  try {
    const headers = buildHeaders('aid');
    response = await axios.post(api.forms.edit.url, payload, { headers });
  } catch (error) {
    return error;
  }
  return response.data?.result;
}
export async function editSiteSvc(payload = {}) {
  console.count('services.editSiteSvc');

  let response = null;
  try {
    const headers = buildHeaders('uid', 'aid');
    response = await axios.post(api.sites.edit.url, payload, { headers });
  } catch (error) {
    return error;
  }
  return response.data?.result;
}

export async function formsGetter(aid) {
  console.count('services.formsGetter');
  const headers = buildHeaders('aid');

  if (aid) {
    headers['x-webforma-aid'] = aid;
  }

  const response = await axios.get(api.forms.url, { headers });
  const forms = response.data?.result || [];
  accountForms.set(forms);

  return forms;

  // TODO: Don't do this, instead provide site data from the API
  // const formsWithSite = await Promise.all(forms.map(async form => {
  //   // let asm = get(accountSiteMap);
  //   // console.info('...formsWithSite', form);
  //   console.log('>> site.start');

  //   let site = await firstValueFrom(accountSites);

  //   console.log('>> site.end', site);
  //   // const site = await getSite({ sid: form.sid });

  //   // accountSiteMap.set({
  //   //   ...asm,
  //   //   [form.sid]: site,
  //   // });

  //   // asm = get(accountSiteMap);

  //   // console.info('formsWithSite.asm', asm);

  //   return { ...form, site };
  // }));

  // return formsWithSite;
}
export async function sitesGetter() {
  console.count('services.sitesGetter');

  const headers = buildHeaders('aid');
  const response = await axios.get(api.sites.url, { headers });
  const result = (response.data?.result || []).sort(alphasort('domain'));

  accountSites.set(result);

  return result;
}

export async function getUserAccount(payload = { aid }) {
  console.count('services.getUserAccount');

  try {
    const $account = get(account);

    if ($account) {
      console.count('userAccount cached');
      return $account;
    }
    const headers = buildHeaders();
    const response = await axios.post(api.account.getAccount.url, payload, { headers });
    const accountFromServer = response.data?.result;

    console.log('account from server', accountFromServer);
    account.set(accountFromServer);

    return accountFromServer;
  } catch (error) {
    console.error('getUserAccount.error', error);
    return null;
  }
}
export async function getBalance(digits = 2) {
  console.count('services.getBalance');

  let response = null;
  try {
    const headers = buildHeaders('aid');
    response = await axios.get(api.account.getBalance.url, { headers });
  } catch (error) {
    return error;
  }

  const credits = response.data || 0;
  const usd = formatMoney(credits / 100, digits);

  return {
    credits,
    usd,
  };
}
export async function getForm(payload = { fid: null }) {
  console.count('services.getForm');

  try {
    const headers = buildHeaders('aid');
    const response = await axios.post(api.forms.view.url, payload, { headers });
    return response.data?.result;
  } catch (error) {
    return null;
  }
}
export async function getForms(aid) {
  console.count('services.getForms');
  const headers = buildHeaders('aid');

  if (aid) {
    headers['x-webforma-aid'] = aid;
  }

  const response = await axios.get(api.forms.url, { headers });
  const forms = response.data?.result || [];
  // TODO: Don't do this, instead provide site data from the API
  const formsWithSite = Promise.all(forms.map(async form => {
    return {
      ...form,
      site: await getSite({ sid: form.sid }),
    };
  }));

  return formsWithSite;
}
export async function getFormsForSite(payload = { sid }) {
  console.count('services.getFormsForSite');

  const headers = buildHeaders('aid');
  const response = await axios.post(api.forms.url, payload, { headers });
  const site = await getSite(payload);
  const forms = response.data?.result || [];
  const formsWithSite = Promise.all(forms.map(async form => {
    return {
      ...form,
      site,
    };
  }));

  return formsWithSite;
}
export async function getHighlights() {
  console.count('services.getHighlights');
  const headers = buildHeaders('aid', 'uid');
  const hasAllHeaders = Object.values(headers).every((a) => a);

  if (!hasAllHeaders) return { sites: 0, forms: 0 };

  const response = await axios.get(api.account.highlights.url, { headers });
  const result = response.data?.result;

  return result;
}
export async function getSubmissions(payload = { fid: null }) {
  console.count('services.getSubmissions');

  let response = null;
  try {
    const headers = buildHeaders('aid');
    response = await axios.post(
      api.submissions.url,
      { page: 1, ...payload },
      {
        headers,
      },
    );
    return response.data;
  } catch (error) {
    const notFound = error?.response?.status === 404;

    if (notFound) {
      return {
        total: 0,
        result: [],
      };
    }
    return error;
  }
}
export async function getSite(payload = { sid }) {
  console.info('==========================================================================');
  const { sid } = payload;
  console.count(`services.getSite ${sid}`);


  return [];

  const headers = buildHeaders('aid');
  const response = await axios.post(api.sites.view.url, payload, { headers });
  const result = response.data?.result;

  console.count(`services.getSite.httpRequest ${sid}`);

  accountSiteMap.pipe(map(a => {
    a[sid] = result;
    return a;
  }))
  // .subscribe(a => console.log('>>>', a));

  return result;
}
export async function getSites() {
  console.count('services.getSites');

  const headers = buildHeaders('aid');
  const response = await axios.get(api.sites.url, { headers });
  return (response.data?.result || []).sort(alphasort('domain'));
}
export async function getSubs() {
  console.count('services.getSubs');

  let response = null;
  try {
    const headers = buildHeaders('aid');
    response = await axios.get(api.account.getSubs.url, {
      headers,
    });
  } catch (error) {
    return error;
  }
  return response;
}
export async function linkGoogleAccount() {
  console.count('services.linkGoogleAccount');

  const $user = get(user);
  const auth = getAuth();
  const provider = new GoogleAuthProvider();
  let linkedUser;

  provider.addScope('https://www.googleapis.com/auth/contacts.readonly');

  try {
    linkedUser = await linkWithPopup(auth.currentUser, provider);
    if (linkedUser) {
      console.log('$$> luser', linkedUser.user);
      const cu = auth.currentUser;
      const [pd] = cu?.providerData || [];

      $user = {
        ...$user,
        ...linkedUser.user,
        photoURL: cu.photoURL || pd.photoURL,
        displayName: pd.displayName,
        providerId: pd.providerId,
        phoneNumber: pd.phoneNumber,
      };
    }
  } catch (error) {
    console.error('failed to link account', error);
  }

  if (!linkedUser) return console.warn('No linked user');

  const headers = buildHeaders('uid');
  const updateRes = await axios.post(api.auth.update.url, $user, {
    headers,
  });

  return updateRes;
}
export async function powerupForm(requestBody = { fid: null, puid: null }) {
  console.count('services.powerupForm');

  const {
    fid, puid, active, settings,
  } = requestBody;

  if (!fid || !puid) {
    return {
      error: [{ message: 'MISSING fid and/or puid' }],
    };
  }

  const payload = { fid, puid };

  if (active !== undefined) {
    payload.active = active;
  }
  if (settings) {
    payload.settings = settings;
  }

  console.log('settings:', payload.settings, payload.active);

  let response = null;
  try {
    const headers = buildHeaders('aid');
    response = await axios.put(api.forms.powerUpForm.url, payload, {
      headers,
    });
  } catch (error) {
    return error;
  }
  return response?.data;
}
export async function updateAuthUser() {
  console.count('services.updateAuthUser');

  const $user = get(user);
  if (!$user) return null;

  let updateRes;
  try {
    const headers = buildHeaders('uid');
    updateRes = await axios.post(api.auth.update.url, $user, {
      headers,
    });
  } catch (error) {
    console.count('failed to update user', $user);
  }
  return updateRes;
}
